module.exports = __webpack_public_path__ + "img/icon-home-tp-02.1024d92d.jpg";